var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "border rounded p-3 d-flex align-items-center" },
          [
            _c("i", { staticClass: "el-icon-loading mr-2" }),
            _vm._v("\n    Carregando dados...\n  ")
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.perfil && !_vm.loading
      ? _c(
          "div",
          [
            _c(
              "b-row",
              { attrs: { "align-v": "end" } },
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary", size: "sm" },
                        on: {
                          click: function($event) {
                            return _vm.verTodos()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-list" }),
                        _vm._v(" Ver Todos")
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right" },
                  [
                    (_vm.perfil == "adm" ||
                      _vm.perfil === "coord-comercial" ||
                      _vm.perfil === "cobranca") &&
                    _vm.dadosFormulario.configuracoes.status === "ATIVO" &&
                    (_vm.dadosFormulario.configuracoes.classe_distribuidor ==
                      "G" ||
                      _vm.dadosFormulario.configuracoes.classe_distribuidor ==
                        "A")
                      ? _c(
                          "b-button",
                          {
                            staticClass: "mr-2",
                            staticStyle: {
                              "background-color": "blueviolet",
                              color: "aliceblue"
                            },
                            attrs: {
                              title: "Solicitar Atualização de Cadastro",
                              size: "sm"
                            },
                            on: { click: _vm.atualizarCadastro }
                          },
                          [
                            _c("i", { staticClass: "fas fa-sync-alt" }),
                            _vm._v(" Solicitar Atualização\n        ")
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.acao != "ver"
                  ? _c(
                      "b-col",
                      { staticClass: "text-right" },
                      [
                        _vm.acao != "ver" &&
                        _vm.dadosFormulario.configuracoes.status !== "ATIVO"
                          ? _c(
                              "b-button",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  variant: "primary",
                                  size: "sm",
                                  disabled: _vm.loadingSave
                                },
                                on: { click: _vm.saveFormularios }
                              },
                              [
                                !_vm.loadingSave
                                  ? _c("i", { staticClass: "fa fa-save" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.loadingSave
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "spinner-border text-primary",
                                        attrs: { role: "status" }
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Loading...")
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v("\n          Salvar\n        ")
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.perfil === "financeiro" ||
                          _vm.perfil === "adm" ||
                          _vm.perfil === "cobranca") &&
                        _vm.dadosFormulario.configuracoes.status ===
                          "AGUARDANDO" &&
                        _vm.anexosAprovados
                          ? _c(
                              "b-button",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  variant: "success",
                                  size: "sm",
                                  title: "Salvar e Aprovar"
                                },
                                on: { click: _vm.ativaCadastro }
                              },
                              [
                                _c("i", { staticClass: "fa fa-thumbs-up" }),
                                _vm._v(" Aprovar\n        ")
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        ((_vm.perfil === "financeiro" ||
                          _vm.perfil === "adm" ||
                          _vm.perfil === "cobranca") &&
                          _vm.dadosFormulario.configuracoes.status ===
                            "AGUARDANDO") ||
                        _vm.dadosFormulario.configuracoes.status ===
                          "PRE-CADASTRO"
                          ? _c(
                              "b-button",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  variant: "third",
                                  size: "sm",
                                  title: "Salvar e Pendenciar"
                                },
                                on: { click: _vm.pendenciarCadastro }
                              },
                              [
                                _c("i", { staticClass: "fas fa-undo" }),
                                _vm._v(" Pendenciar\n        ")
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.perfil === "financeiro" ||
                          _vm.perfil === "adm" ||
                          _vm.perfil === "coord-comercial" ||
                          _vm.perfil === "cobranca") &&
                        !_vm.dadosFormulario.configuracoes
                          .codigo_distribuidor &&
                        (_vm.dadosFormulario.configuracoes.status ===
                          "AGUARDANDO" ||
                          _vm.dadosFormulario.configuracoes.status ===
                            "DIGITADO" ||
                          _vm.dadosFormulario.configuracoes.status ===
                            "PENDENTE")
                          ? _c(
                              "b-button",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  variant: "danger",
                                  size: "sm",
                                  title: "Salvar e Inativar"
                                },
                                on: { click: _vm.inativarCadastro }
                              },
                              [
                                _c("i", { staticClass: "fas fa-window-close" }),
                                _vm._v(" Inativar\n        ")
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-card",
                      { staticClass: "mt-2" },
                      [
                        _c(
                          "b-card-body",
                          [
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c("b-col", { attrs: { cols: "9" } }, [
                                  _c("h5", [
                                    _vm._v(
                                      "\n                  Formulário Prospecto\n                  "
                                    ),
                                    _c("b", [
                                      _vm.dadosFormulario.empresa.nome_fantasia
                                        ? _c("span", [
                                            _vm._v(
                                              "| " +
                                                _vm._s(
                                                  _vm.dadosFormulario.empresa
                                                    .nome_fantasia
                                                )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.dadosFormulario.configuracoes
                                        .codigo_distribuidor
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                      - " +
                                                _vm._s(
                                                  _vm.dadosFormulario
                                                    .configuracoes
                                                    .codigo_distribuidor
                                                ) +
                                                "\n                    "
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "text-right",
                                    attrs: { cols: "3" }
                                  },
                                  [
                                    _c(
                                      "h4",
                                      [
                                        _vm.dadosFormulario.configuracoes
                                          .status === "PRE-CADASTRO"
                                          ? _c(
                                              "b-badge",
                                              { attrs: { variant: "third" } },
                                              [_vm._v("PRE-CADASTRO")]
                                            )
                                          : _vm.dadosFormulario.configuracoes
                                              .status === "DIGITADO"
                                          ? _c(
                                              "b-badge",
                                              { attrs: { variant: "primary" } },
                                              [_vm._v("DIGITADO")]
                                            )
                                          : _vm.dadosFormulario.configuracoes
                                              .status === "AGUARDANDO"
                                          ? _c(
                                              "b-badge",
                                              { attrs: { variant: "warning" } },
                                              [_vm._v("AGUARDANDO")]
                                            )
                                          : _vm.dadosFormulario.configuracoes
                                              .status === "INATIVO"
                                          ? _c(
                                              "b-badge",
                                              { attrs: { variant: "danger" } },
                                              [_vm._v("INATIVO")]
                                            )
                                          : _vm.dadosFormulario.configuracoes
                                              .status === "ATIVO"
                                          ? _c(
                                              "b-badge",
                                              { attrs: { variant: "success" } },
                                              [_vm._v("ATIVO")]
                                            )
                                          : _vm.dadosFormulario.configuracoes
                                              .status === "PENDENTE"
                                          ? _c(
                                              "b-badge",
                                              { attrs: { variant: "danger" } },
                                              [_vm._v("PENDENTE")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            (_vm.perfil === "financeiro" ||
                              _vm.perfil === "adm" ||
                              _vm.perfil === "cobranca") &&
                            _vm.prospectoId > 0 &&
                            _vm.duplicatasEncontradas.length > 0
                              ? _c(
                                  "b-row",
                                  { staticClass: "mt-1 mb-1" },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-alert",
                                          {
                                            staticClass:
                                              "mb-0 d-flex align-items-center justify-content-between py-2",
                                            attrs: {
                                              variant: "warning",
                                              show: ""
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-exclamation-triangle mr-1"
                                              }),
                                              _vm._v(" "),
                                              _c("strong", [
                                                _vm._v("Atenção:")
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.duplicatasEncontradas
                                                      .length
                                                  ) +
                                                  " outro(s) cadastro(s) possuem telefone ou endereço coincidentes com este cadastro.\n                  "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "ml-3 flex-shrink-0",
                                                attrs: {
                                                  size: "sm",
                                                  variant: "warning"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.modalDuplicatas = true
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fas fa-search"
                                                }),
                                                _vm._v(
                                                  " Ver Cadastros\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("b-row", { attrs: { "align-v": "end" } }, [
                              _c("div", { staticClass: "col-md-2" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("Tipo de Cadastro:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.dadosFormulario.configuracoes
                                              .tipo_cadastro,
                                          expression:
                                            "dadosFormulario.configuracoes.tipo_cadastro"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: { name: "", id: "" },
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.dadosFormulario.configuracoes,
                                              "tipo_cadastro",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function($event) {
                                            return _vm.changeTipoCadastro(
                                              _vm.dadosFormulario.configuracoes
                                                .tipo_cadastro
                                            )
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { value: "NOVO" } },
                                        [_vm._v("Novo")]
                                      ),
                                      _vm._v(" "),
                                      _vm.perfil == "coord_comercial" ||
                                      _vm.perfil == "cobranca" ||
                                      _vm.perfil == "financeiro" ||
                                      _vm.perfil == "comercial" ||
                                      _vm.perfil == "adm" ||
                                      _vm.dadosFormulario.configuracoes
                                        .tipo_cadastro === "MIGRACAO"
                                        ? _c(
                                            "option",
                                            { attrs: { value: "MIGRACAO" } },
                                            [_vm._v("Migração")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "REATIVACAO" } },
                                        [_vm._v("Reativação")]
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Região:")
                                    ]),
                                    _vm._v(" "),
                                    _c("b-select", {
                                      attrs: {
                                        options: _vm.showRegioes,
                                        "value-field": "id",
                                        "text-field": "label",
                                        disabled:
                                          _vm.perfil === "centro_distribuicao"
                                      },
                                      model: {
                                        value:
                                          _vm.dadosFormulario.configuracoes
                                            .regiao_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dadosFormulario.configuracoes,
                                            "regiao_id",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dadosFormulario.configuracoes.regiao_id"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Classe Distribuidor:",
                                          "label-for": "classe-distribuidor"
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            id: "classe-distribuidor",
                                            disabled:
                                              _vm.dadosFormulario.configuracoes
                                                .status !== "PRE-CADASTRO" &&
                                              _vm.dadosFormulario.configuracoes
                                                .status !== "DIGITADO" &&
                                              _vm.dadosFormulario.configuracoes
                                                .status !== "PENDENTE" &&
                                              _vm.dadosFormulario.configuracoes
                                                .status !== "AGUARDANDO" &&
                                              _vm.prospectoId > 0,
                                            options: _vm.showOptionsClasse
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.showKit &&
                                                _vm.changeTipoPagamento
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.dadosFormulario.configuracoes
                                                .classe_distribuidor,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dadosFormulario
                                                  .configuracoes,
                                                "classe_distribuidor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dadosFormulario.configuracoes.classe_distribuidor\n                        "
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _vm.dadosFormulario.configuracoes
                                .classe_distribuidor !== "V"
                                ? _c("div", { staticClass: "col-md-3" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c(
                                            "b-form-group",
                                            { attrs: { label: "Consultor:" } },
                                            [
                                              _c("b-form-select", {
                                                attrs: {
                                                  disabled:
                                                    _vm.dadosFormulario
                                                      .configuracoes.status !==
                                                      "DIGITADO" &&
                                                    _vm.propProspectoId > 0 &&
                                                    _vm.consultorValido,
                                                  options:
                                                    _vm.showOptionsConsultor
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosFormulario
                                                      .configuracoes
                                                      .codigo_vendedor,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosFormulario
                                                        .configuracoes,
                                                      "codigo_vendedor",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosFormulario.configuracoes.codigo_vendedor"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                : _c("div", { staticClass: "col-md-3" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c(
                                            "b-form-group",
                                            { attrs: { label: "Gerente:" } },
                                            [
                                              _c("b-form-select", {
                                                attrs: {
                                                  disabled:
                                                    _vm.dadosFormulario
                                                      .configuracoes.status !==
                                                      "DIGITADO" &&
                                                    _vm.propProspectoId > 0 &&
                                                    _vm.consultorValido,
                                                  options:
                                                    _vm.showOptionsGerente
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosFormulario
                                                      .configuracoes
                                                      .codigo_vendedor,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosFormulario
                                                        .configuracoes,
                                                      "codigo_vendedor",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosFormulario.configuracoes.codigo_vendedor"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ]),
                              _vm._v(" "),
                              _vm.dadosFormulario.configuracoes
                                .classe_distribuidor == "V" &&
                              (_vm.perfil === "adm" ||
                                _vm.perfil === "representante_varejo" ||
                                _vm.perfil === "gerente_varejo" ||
                                _vm.perfil === "list_prospecto" ||
                                _vm.perfil === "analista_farma" ||
                                _vm.perfil === "supervisor_externo" ||
                                _vm.perfil === "diretor_nacional" ||
                                _vm.perfil === "gerente_nacional" ||
                                _vm.perfil === "gerente_regional" ||
                                _vm.perfil === "gerente_distrital" ||
                                _vm.perfil === "cobranca")
                                ? _c("div", { staticClass: "col-md-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Representante:")
                                        ]),
                                        _vm._v(" "),
                                        _c("b-form-select", {
                                          attrs: {
                                            disabled:
                                              _vm.dadosFormulario.configuracoes
                                                .status !== "DIGITADO" ||
                                              (_vm.representante !== "" &&
                                                _vm.perfil !== "adm" &&
                                                _vm.perfil !==
                                                  "gestor_varejo" &&
                                                _vm.perfil !==
                                                  "list_prospecto" &&
                                                _vm.perfil !==
                                                  "supervisor_externo" &&
                                                _vm.perfil !== "cobranca"),
                                            options: _vm.representantes
                                          },
                                          model: {
                                            value: _vm.representante,
                                            callback: function($$v) {
                                              _vm.representante = $$v
                                            },
                                            expression: "representante"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              {
                                staticClass: "mt-3",
                                attrs: { "align-v": "start" }
                              },
                              [
                                _c("div", { staticClass: "col-md-2" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Centro de Distribuição:")
                                      ]),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          disabled:
                                            _vm.dadosFormulario.configuracoes
                                              .status !== "DIGITADO",
                                          options: _vm.listaCentroDistribuicao
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.setCd()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.dadosFormulario.configuracoes
                                              .centro_distribuicao,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosFormulario.configuracoes,
                                              "centro_distribuicao",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dadosFormulario.configuracoes.centro_distribuicao"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.perfil == "adm"
                                  ? _c("div", { staticClass: "col-md-2" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Usuário")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.dadosFormulario
                                                    .configuracoes.user_id,
                                                expression:
                                                  "dadosFormulario.configuracoes.user_id"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: { name: "", id: "" },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.$set(
                                                  _vm.dadosFormulario
                                                    .configuracoes,
                                                  "user_id",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              }
                                            }
                                          },
                                          _vm._l(_vm.users, function(user, u) {
                                            return _c(
                                              "option",
                                              {
                                                key: u,
                                                domProps: { value: user.id }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(user.name) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.getRolesUser(
                                                        user.roles
                                                      )
                                                    ) +
                                                    ")\n                    "
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.dadosFormulario.configuracoes
                                  .centro_distribuicao == 10
                                  ? _c(
                                      "div",
                                      { staticClass: "col-md-6 mt-3" },
                                      [
                                        _c("b-form-group", {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var ariaDescribedby =
                                                    ref.ariaDescribedby
                                                  return [
                                                    _c("b-form-radio-group", {
                                                      attrs: {
                                                        disabled:
                                                          _vm.prospectoId > 0,
                                                        id: "radio-group-1",
                                                        options:
                                                          _vm.optionsRadio,
                                                        "aria-describedby": ariaDescribedby,
                                                        name: "radio-options"
                                                      },
                                                      model: {
                                                        value: _vm.tipoCadastro,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.tipoCadastro = $$v
                                                        },
                                                        expression:
                                                          "tipoCadastro"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2987142541
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.dadosFormulario.configuracoes
                                  .tipo_cadastro == "MIGRACAO" ||
                                _vm.dadosFormulario.configuracoes
                                  .tipo_cadastro == "REATIVACAO"
                                  ? _c("b-col", { staticClass: "col-md-2" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Código Anterior")
                                          ]),
                                          _vm._v(" "),
                                          !_vm.dadosFormulario.configuracoes
                                            .codigo_anterior
                                            ? _c("v-busca-distribuidor", {
                                                attrs: { label_text: "" },
                                                model: {
                                                  value:
                                                    _vm.dadosFormulario
                                                      .configuracoes
                                                      .codigo_anterior,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosFormulario
                                                        .configuracoes,
                                                      "codigo_anterior",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosFormulario.configuracoes.codigo_anterior"
                                                }
                                              })
                                            : _c("div", [
                                                _c("strong", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.dadosFormulario
                                                          .configuracoes
                                                          .codigo_anterior
                                                          .codigo
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removeAnterior()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-times"
                                                    })
                                                  ]
                                                )
                                              ])
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "col-md-6" },
                                  [
                                    _c("label", [_vm._v("Indicado Por:")]),
                                    _vm._v(" "),
                                    _c(
                                      "v-select",
                                      {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value: ["#######"],
                                            expression: "['#######']"
                                          }
                                        ],
                                        attrs: {
                                          options: _vm.listaDistribuidores,
                                          placeholder: "Código do Distribuidor",
                                          disabled:
                                            _vm.loadingBuscaDistribuidor ||
                                            (_vm.dadosFormulario.configuracoes
                                              .status !== "DIGITADO" &&
                                              _vm.dadosFormulario.configuracoes
                                                .status !== "PENDENTE") ||
                                            _vm.dadosFormulario.configuracoes
                                              .tipo_cadastro != "NOVO"
                                        },
                                        on: {
                                          search: _vm.buscaDistribuidor,
                                          change: _vm.selectIndicante
                                        },
                                        model: {
                                          value: _vm.indicanteSelecionado,
                                          callback: function($$v) {
                                            _vm.indicanteSelecionado = $$v
                                          },
                                          expression: "indicanteSelecionado"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "no-options" },
                                            slot: "no-options"
                                          },
                                          [
                                            _vm._v(
                                              "Nenhum distribuidor encontrado"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-tabs",
                              {
                                staticClass: "prospect-menu",
                                attrs: {
                                  "content-class": "mt-3",
                                  fill: "",
                                  "active-tab-class":
                                    "font-weight-bold bg-secondary text-primary",
                                  card: ""
                                }
                              },
                              [
                                _c(
                                  "b-tab",
                                  {
                                    staticClass: "prospect-menu",
                                    attrs: {
                                      title: !_vm.tipoCadastro
                                        ? "Empresa"
                                        : "Cliente",
                                      "title-item-class":
                                        "bg-primary text-secondary",
                                      active: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      [
                                        _c("b-card-header", [
                                          !_vm.tipoCadastro
                                            ? _c("span", [
                                                _vm._v("Dados da Empresa")
                                              ])
                                            : _c("span", [
                                                _vm._v("Dados do Cliente")
                                              ])
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-card-body",
                                          [
                                            _c(
                                              "b-row",
                                              {
                                                attrs: { "align-v": "center" }
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { cols: "6" } },
                                                  [
                                                    !_vm.tipoCadastro
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "checkbox"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dadosFormulario
                                                                        .empresa
                                                                        .cadastro_mei,
                                                                    expression:
                                                                      "dadosFormulario.empresa.cadastro_mei"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  type:
                                                                    "checkbox"
                                                                },
                                                                domProps: {
                                                                  checked: Array.isArray(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa
                                                                      .cadastro_mei
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm
                                                                          .dadosFormulario
                                                                          .empresa
                                                                          .cadastro_mei,
                                                                        null
                                                                      ) > -1
                                                                    : _vm
                                                                        .dadosFormulario
                                                                        .empresa
                                                                        .cadastro_mei
                                                                },
                                                                on: {
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .dadosFormulario
                                                                          .empresa
                                                                          .cadastro_mei,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c = $$el.checked
                                                                        ? true
                                                                        : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v = null,
                                                                        $$i = _vm._i(
                                                                          $$a,
                                                                          $$v
                                                                        )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .dadosFormulario
                                                                              .empresa,
                                                                            "cadastro_mei",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .dadosFormulario
                                                                              .empresa,
                                                                            "cadastro_mei",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .dadosFormulario
                                                                          .empresa,
                                                                        "cadastro_mei",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(
                                                                "\n                            Cadastrado MEI\n                          "
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { cols: "6" } },
                                                  [
                                                    !_vm.tipoCadastro
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "checkbox"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .dadosFormulario
                                                                        .empresa
                                                                        .assinado_gov,
                                                                    expression:
                                                                      "dadosFormulario.empresa.assinado_gov"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  type:
                                                                    "checkbox"
                                                                },
                                                                domProps: {
                                                                  checked: Array.isArray(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa
                                                                      .assinado_gov
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm
                                                                          .dadosFormulario
                                                                          .empresa
                                                                          .assinado_gov,
                                                                        null
                                                                      ) > -1
                                                                    : _vm
                                                                        .dadosFormulario
                                                                        .empresa
                                                                        .assinado_gov
                                                                },
                                                                on: {
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .dadosFormulario
                                                                          .empresa
                                                                          .assinado_gov,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c = $$el.checked
                                                                        ? true
                                                                        : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v = null,
                                                                        $$i = _vm._i(
                                                                          $$a,
                                                                          $$v
                                                                        )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .dadosFormulario
                                                                              .empresa,
                                                                            "assinado_gov",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .dadosFormulario
                                                                              .empresa,
                                                                            "assinado_gov",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .dadosFormulario
                                                                          .empresa,
                                                                        "assinado_gov",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(
                                                                "\n                            Assinado via Gov?\n                          "
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            !_vm.tipoCadastro
                                              ? _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-6"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-group"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Razão Social:"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa
                                                                      .razao_social,
                                                                  expression:
                                                                    "dadosFormulario.empresa.razao_social"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .empresa
                                                                    .razao_social
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa,
                                                                    "razao_social",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-6"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-group"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Nome Fantasia:"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa
                                                                      .nome_fantasia,
                                                                  expression:
                                                                    "dadosFormulario.empresa.nome_fantasia"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .empresa
                                                                    .nome_fantasia
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa,
                                                                    "nome_fantasia",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.tipoCadastro
                                              ? _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-4"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-group"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v("CNPJ:")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa
                                                                      .cnpj,
                                                                  expression:
                                                                    "dadosFormulario.empresa.cnpj"
                                                                },
                                                                {
                                                                  name: "mask",
                                                                  rawName:
                                                                    "v-mask",
                                                                  value: [
                                                                    "##.###.###/####-##"
                                                                  ],
                                                                  expression:
                                                                    "['##.###.###/####-##']"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                type: "text",
                                                                placeholder:
                                                                  "00.000.000/0001-00"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .empresa
                                                                    .cnpj
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa,
                                                                    "cnpj",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "vConsultaReceitaFederal",
                                                              {
                                                                attrs: {
                                                                  cnpj:
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa
                                                                      .cnpj
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-4"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-group"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Inscrição Estadual:"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa
                                                                      .inscricao_estadual,
                                                                  expression:
                                                                    "dadosFormulario.empresa.inscricao_estadual"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                error:
                                                                  !_vm.isValidInscricaoEstadual &&
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .empresa
                                                                    .inscricao_estadual
                                                                    .length >
                                                                    3 &&
                                                                  _vm.invalidInscricao
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .empresa
                                                                    .inscricao_estadual
                                                              },
                                                              on: {
                                                                focusout:
                                                                  _vm.verificarInscricaoEstadual,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa,
                                                                    "inscricao_estadual",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _vm.erroInscricao &&
                                                            _vm.invalidInscricao &&
                                                            !_vm.loadingIsncricao
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.erroInscricao
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.loadingIsncricao
                                                              ? _c("div", [
                                                                  _vm._v(
                                                                    "Verificando Inscrição..."
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.dadosFormulario
                                                      .proprietario != null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-md-4"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v("E-Mail")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .proprietario
                                                                      .email,
                                                                  expression:
                                                                    "dadosFormulario.proprietario.email"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                type: "email",
                                                                placeholder:
                                                                  "Ex: exemplo@email.com"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .proprietario
                                                                    .email
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .proprietario,
                                                                    "email",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.tipoCadastro
                                              ? _c(
                                                  "el-row",
                                                  {
                                                    staticClass: "mb-4",
                                                    attrs: { gutter: 12 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-col",
                                                      {
                                                        staticClass: "mb-2",
                                                        attrs: { span: 24 }
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Contatos da Empresa:"
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "el-col",
                                                      [
                                                        _c(
                                                          "el-row",
                                                          {
                                                            attrs: {
                                                              gutter: 12
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.dadosFormulario
                                                              .empresa.contatos,
                                                            function(
                                                              contato,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "el-col",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "mb-3",
                                                                  attrs: {
                                                                    span: 12
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-contato",
                                                                    {
                                                                      ref:
                                                                        "contatoEmpresa",
                                                                      refInFor: true,
                                                                      attrs: {
                                                                        id: index,
                                                                        backgroundColor:
                                                                          "#f0eeee",
                                                                        removable:
                                                                          _vm
                                                                            .dadosFormulario
                                                                            .empresa
                                                                            .contatos
                                                                            .length >
                                                                          2
                                                                      },
                                                                      on: {
                                                                        delete:
                                                                          _vm.deleteContatoEmpresa
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .dadosFormulario
                                                                            .empresa
                                                                            .contatos[
                                                                            index
                                                                          ],
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .dadosFormulario
                                                                              .empresa
                                                                              .contatos,
                                                                            index,
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "dadosFormulario.empresa.contatos[index]"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "el-col",
                                                      { staticClass: "col-4" },
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary",
                                                              size: "medium",
                                                              plain: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.addContato(
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .empresa
                                                                    .contatos
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-plus mr-1"
                                                            }),
                                                            _vm._v(
                                                              " \n                          Adicionar contato\n                        "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "el-row",
                                              { attrs: { gutter: 12 } },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "mb-4" },
                                                      [
                                                        !_vm.tipoCadastro
                                                          ? _c("strong", [
                                                              _vm._v(
                                                                "Endereço da Empresa:"
                                                              )
                                                            ])
                                                          : _c("strong", [
                                                              _vm._v(
                                                                "Endereço do Cliente:"
                                                              )
                                                            ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    (!_vm.loading ||
                                                      (_vm.acao == "import" &&
                                                        !_vm.loadingImport)) &&
                                                    _vm.perfil
                                                      ? _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              [
                                                                _c(
                                                                  "vEndereco",
                                                                  {
                                                                    ref:
                                                                      "enderecoEmpresa",
                                                                    on: {
                                                                      prazos:
                                                                        _vm.prazos
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .dadosFormulario
                                                                          .empresa
                                                                          .endereco,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .dadosFormulario
                                                                            .empresa,
                                                                          "endereco",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "dadosFormulario.empresa.endereco"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-between mb-4"
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Endereço de Entrega:"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-group mb-0"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "checkbox"
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                Usar o mesmo Endereço\n                                "
                                                                    ),
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.copyEnderecoEntrega,
                                                                            expression:
                                                                              "copyEnderecoEntrega"
                                                                          }
                                                                        ],
                                                                        attrs: {
                                                                          type:
                                                                            "checkbox"
                                                                        },
                                                                        domProps: {
                                                                          checked: Array.isArray(
                                                                            _vm.copyEnderecoEntrega
                                                                          )
                                                                            ? _vm._i(
                                                                                _vm.copyEnderecoEntrega,
                                                                                null
                                                                              ) >
                                                                              -1
                                                                            : _vm.copyEnderecoEntrega
                                                                        },
                                                                        on: {
                                                                          change: [
                                                                            function(
                                                                              $event
                                                                            ) {
                                                                              var $$a =
                                                                                  _vm.copyEnderecoEntrega,
                                                                                $$el =
                                                                                  $event.target,
                                                                                $$c = $$el.checked
                                                                                  ? true
                                                                                  : false
                                                                              if (
                                                                                Array.isArray(
                                                                                  $$a
                                                                                )
                                                                              ) {
                                                                                var $$v = null,
                                                                                  $$i = _vm._i(
                                                                                    $$a,
                                                                                    $$v
                                                                                  )
                                                                                if (
                                                                                  $$el.checked
                                                                                ) {
                                                                                  $$i <
                                                                                    0 &&
                                                                                    (_vm.copyEnderecoEntrega = $$a.concat(
                                                                                      [
                                                                                        $$v
                                                                                      ]
                                                                                    ))
                                                                                } else {
                                                                                  $$i >
                                                                                    -1 &&
                                                                                    (_vm.copyEnderecoEntrega = $$a
                                                                                      .slice(
                                                                                        0,
                                                                                        $$i
                                                                                      )
                                                                                      .concat(
                                                                                        $$a.slice(
                                                                                          $$i +
                                                                                            1
                                                                                        )
                                                                                      ))
                                                                                }
                                                                              } else {
                                                                                _vm.copyEnderecoEntrega = $$c
                                                                              }
                                                                            },
                                                                            _vm.copiarEnderecoParaEntrega
                                                                          ]
                                                                        }
                                                                      }
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "row",
                                                        style: {
                                                          pointerEvents: !_vm.copyEnderecoEntrega
                                                            ? "auto"
                                                            : "none",
                                                          opacity: !_vm.copyEnderecoEntrega
                                                            ? "100%"
                                                            : "50%"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-col",
                                                          [
                                                            _c("vEndereco", {
                                                              ref:
                                                                "enderecoEntrega",
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .empresa
                                                                    .endereco_entrega,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .empresa,
                                                                    "endereco_entrega",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "dadosFormulario.empresa.endereco_entrega"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: "Configurações",
                                      "title-item-class":
                                        "bg-primary text-secondary"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: {
                                          header: "Configurações e Financeiro"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-card-body",
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { cols: "4" } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: { for: "" }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Código Distribuidor:"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .codigo_distribuidor,
                                                              expression:
                                                                "dadosFormulario.configuracoes.codigo_distribuidor\n                            "
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            disabled: "",
                                                            type: "text"
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm
                                                                .dadosFormulario
                                                                .configuracoes
                                                                .codigo_distribuidor
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes,
                                                                "codigo_distribuidor",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { cols: "4" } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: { for: "" }
                                                          },
                                                          [_vm._v("Pagamento:")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "select",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes
                                                                    .pagamento,
                                                                expression:
                                                                  "dadosFormulario.configuracoes.pagamento"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            attrs: {
                                                              name: "",
                                                              id: ""
                                                            },
                                                            on: {
                                                              change: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.$set(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .configuracoes,
                                                                    "pagamento",
                                                                    $event
                                                                      .target
                                                                      .multiple
                                                                      ? $$selectedVal
                                                                      : $$selectedVal[0]
                                                                  )
                                                                },
                                                                _vm.changeTipoPagamento
                                                              ]
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "option",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "BOLETO"
                                                                }
                                                              },
                                                              [_vm._v("Boleto")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "option",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    "TRANSFERENCIA"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Depósito"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.perfil ===
                                                            "financeiro" ||
                                                          _vm.perfil ===
                                                            "adm" ||
                                                          _vm.perfil ===
                                                            "cobranca",
                                                        expression:
                                                          "perfil === 'financeiro' || perfil === 'adm' || perfil === 'cobranca'"
                                                      }
                                                    ],
                                                    attrs: { cols: "4" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: { for: "" }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Limite de Crédito:"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "mask",
                                                              rawName: "v-mask",
                                                              value: [
                                                                "#",
                                                                "#.#",
                                                                "#.##",
                                                                "##.##",
                                                                "###.##",
                                                                "####.##",
                                                                "#####.##",
                                                                "######.##",
                                                                "#######.##"
                                                              ],
                                                              expression:
                                                                "[\n                            '#',\n                            '#.#',\n                            '#.##',\n                            '##.##',\n                            '###.##',\n                            '####.##',\n                            '#####.##',\n                            '######.##',\n                            '#######.##',\n                          ]"
                                                            },
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .limite_credito,
                                                              expression:
                                                                "dadosFormulario.configuracoes.limite_credito\n                            "
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text"
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm
                                                                .dadosFormulario
                                                                .configuracoes
                                                                .limite_credito
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes,
                                                                "limite_credito",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          (_vm.perfil ===
                                                            "financeiro" ||
                                                            _vm.perfil ===
                                                              "adm" ||
                                                            _vm.perfil ===
                                                              "cobranca") &&
                                                          _vm.dadosFormulario
                                                            .configuracoes
                                                            .classe_distribuidor ===
                                                            "G",
                                                        expression:
                                                          "(perfil === 'financeiro' || perfil === 'adm' || perfil === 'cobranca') && dadosFormulario.configuracoes.classe_distribuidor === 'G'"
                                                      }
                                                    ],
                                                    attrs: { cols: "4" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: { for: "" }
                                                          },
                                                          [_vm._v(" ")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-form-checkbox",
                                                          {
                                                            attrs: {
                                                              switch: ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .cnae_pendente,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes,
                                                                  "cnae_pendente",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "dadosFormulario.configuracoes.cnae_pendente"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Pendência de CNAE (fora do padrão)\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-4" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group"
                                                    },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            description:
                                                              "Antes de selecionar o prazo, preencha o CEP da empresa no cadastro.",
                                                            label:
                                                              "Prazo Pagamento:",
                                                            "label-for":
                                                              "prazo-pagamento"
                                                          }
                                                        },
                                                        [
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              id:
                                                                "prazo-pagamento",
                                                              disabled:
                                                                _vm
                                                                  .showPrazosPagamento
                                                                  .length <=
                                                                  1 ||
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .pagamento ===
                                                                  "TRANSFERENCIA",
                                                              options:
                                                                _vm.showPrazosPagamento
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .prazo_pagamento,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes,
                                                                  "prazo_pagamento",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "dadosFormulario.configuracoes.prazo_pagamento"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-4" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        { attrs: { for: "" } },
                                                        [
                                                          _vm._v(
                                                            "Qtd. Revendedoras:"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value: ["####"],
                                                            expression:
                                                              "['####']"
                                                          },
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .dadosFormulario
                                                                .configuracoes
                                                                .qtd_revendedoras,
                                                            expression:
                                                              "dadosFormulario.configuracoes.qtd_revendedoras\n                            "
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: { type: "text" },
                                                        domProps: {
                                                          value:
                                                            _vm.dadosFormulario
                                                              .configuracoes
                                                              .qtd_revendedoras
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              _vm
                                                                .dadosFormulario
                                                                .configuracoes,
                                                              "qtd_revendedoras",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.dadosFormulario.configuracoes
                                                .classe_distribuidor == "A" ||
                                              _vm.dadosFormulario.configuracoes
                                                .classe_distribuidor == "P"
                                                ? _c(
                                                    "div",
                                                    { staticClass: "col-md-4" },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          "Cadastro Matriz"
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "mask",
                                                              rawName: "v-mask",
                                                              value: [
                                                                "#######"
                                                              ],
                                                              expression:
                                                                "['#######']"
                                                            }
                                                          ],
                                                          attrs: {
                                                            options:
                                                              _vm.listaDistribuidores,
                                                            placeholder:
                                                              "Código do Distribuidor",
                                                            disabled:
                                                              _vm.loadingBuscaDistribuidor ||
                                                              (_vm
                                                                .dadosFormulario
                                                                .configuracoes
                                                                .status !==
                                                                "DIGITADO" &&
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .status !==
                                                                  "PENDENTE") ||
                                                              _vm
                                                                .dadosFormulario
                                                                .configuracoes
                                                                .tipo_cadastro !=
                                                                "NOVO"
                                                          },
                                                          on: {
                                                            search:
                                                              _vm.buscaDistribuidor,
                                                            change:
                                                              _vm.selectMatriz
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.matrizSelecionado,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.matrizSelecionado = $$v
                                                            },
                                                            expression:
                                                              "matrizSelecionado"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot:
                                                                  "no-options"
                                                              },
                                                              slot: "no-options"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            Nenhum distribuidor encontrado\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.dadosFormulario.configuracoes
                                                .classe_distribuidor === "V"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "col-md-4",
                                                      attrs: {
                                                        "dadosFormulario.configuracoes.classe_distribuidor":
                                                          ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-group"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              attrs: {
                                                                for: "port"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Porte da Empresa:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              id: "port",
                                                              options:
                                                                _vm.optionsPorte
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .porte,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes,
                                                                  "porte",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "dadosFormulario.configuracoes.porte"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.show &&
                                                        _vm.dadosFormulario
                                                          .configuracoes
                                                          .classe_distribuidor !==
                                                          "L" &&
                                                        _vm.dadosFormulario
                                                          .configuracoes
                                                          .tipo_cadastro ==
                                                          "NOVO",
                                                      expression:
                                                        "show &&\n                        dadosFormulario.configuracoes.classe_distribuidor !==\n                        'L' &&\n                        dadosFormulario.configuracoes.tipo_cadastro =='NOVO'\n                        "
                                                    }
                                                  ],
                                                  staticClass: "col-md-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "checkbox" },
                                                    [
                                                      _c("label", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .kit_super_credito,
                                                              expression:
                                                                "dadosFormulario.configuracoes.kit_super_credito\n                            "
                                                            }
                                                          ],
                                                          attrs: {
                                                            type: "checkbox"
                                                          },
                                                          domProps: {
                                                            checked: Array.isArray(
                                                              _vm
                                                                .dadosFormulario
                                                                .configuracoes
                                                                .kit_super_credito
                                                            )
                                                              ? _vm._i(
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes
                                                                    .kit_super_credito,
                                                                  null
                                                                ) > -1
                                                              : _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .kit_super_credito
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$a =
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes
                                                                    .kit_super_credito,
                                                                $$el =
                                                                  $event.target,
                                                                $$c = $$el.checked
                                                                  ? true
                                                                  : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = null,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    _vm.$set(
                                                                      _vm
                                                                        .dadosFormulario
                                                                        .configuracoes,
                                                                      "kit_super_credito",
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      )
                                                                    )
                                                                } else {
                                                                  $$i > -1 &&
                                                                    _vm.$set(
                                                                      _vm
                                                                        .dadosFormulario
                                                                        .configuracoes,
                                                                      "kit_super_credito",
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        )
                                                                    )
                                                                }
                                                              } else {
                                                                _vm.$set(
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes,
                                                                  "kit_super_credito",
                                                                  $$c
                                                                )
                                                              }
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                            Kit Super Crédito"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.show &&
                                                        _vm.dadosFormulario
                                                          .configuracoes
                                                          .tipo_cadastro ==
                                                          "NOVO" &&
                                                        (_vm.dadosFormulario
                                                          .configuracoes
                                                          .classe_distribuidor ===
                                                          "A" ||
                                                          _vm.dadosFormulario
                                                            .configuracoes
                                                            .classe_distribuidor ===
                                                            "G" ||
                                                          _vm.dadosFormulario
                                                            .configuracoes
                                                            .classe_distribuidor ===
                                                            "L"),
                                                      expression:
                                                        "show &&\n                        dadosFormulario.configuracoes.tipo_cadastro =='NOVO' &&\n                        (dadosFormulario.configuracoes.classe_distribuidor === 'A' ||\n                          dadosFormulario.configuracoes.classe_distribuidor === 'G' ||\n                          dadosFormulario.configuracoes.classe_distribuidor === 'L'\n                        )"
                                                    }
                                                  ],
                                                  staticClass: "col-md-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "checkbox" },
                                                    [
                                                      _c("label", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .kit_personalizado,
                                                              expression:
                                                                "dadosFormulario.configuracoes.kit_personalizado"
                                                            }
                                                          ],
                                                          attrs: {
                                                            type: "checkbox",
                                                            disabled: "",
                                                            value:
                                                              "kit_personalizado"
                                                          },
                                                          domProps: {
                                                            checked: Array.isArray(
                                                              _vm
                                                                .dadosFormulario
                                                                .configuracoes
                                                                .kit_personalizado
                                                            )
                                                              ? _vm._i(
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes
                                                                    .kit_personalizado,
                                                                  "kit_personalizado"
                                                                ) > -1
                                                              : _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .kit_personalizado
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$a =
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .configuracoes
                                                                      .kit_personalizado,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c = $$el.checked
                                                                    ? true
                                                                    : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      "kit_personalizado",
                                                                    $$i = _vm._i(
                                                                      $$a,
                                                                      $$v
                                                                    )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      _vm.$set(
                                                                        _vm
                                                                          .dadosFormulario
                                                                          .configuracoes,
                                                                        "kit_personalizado",
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        )
                                                                      )
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      _vm.$set(
                                                                        _vm
                                                                          .dadosFormulario
                                                                          .configuracoes,
                                                                        "kit_personalizado",
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          )
                                                                      )
                                                                  }
                                                                } else {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .configuracoes,
                                                                    "kit_personalizado",
                                                                    $$c
                                                                  )
                                                                }
                                                              },
                                                              _vm.validCheckCadastro
                                                            ]
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                            Kit Personalizado\n                          "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-3" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "checkbox" },
                                                    [
                                                      _c("label", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .ecommerce,
                                                              expression:
                                                                "dadosFormulario.configuracoes.ecommerce"
                                                            }
                                                          ],
                                                          attrs: {
                                                            type: "checkbox"
                                                          },
                                                          domProps: {
                                                            checked: Array.isArray(
                                                              _vm
                                                                .dadosFormulario
                                                                .configuracoes
                                                                .ecommerce
                                                            )
                                                              ? _vm._i(
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes
                                                                    .ecommerce,
                                                                  null
                                                                ) > -1
                                                              : _vm
                                                                  .dadosFormulario
                                                                  .configuracoes
                                                                  .ecommerce
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$a =
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes
                                                                    .ecommerce,
                                                                $$el =
                                                                  $event.target,
                                                                $$c = $$el.checked
                                                                  ? true
                                                                  : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = null,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    _vm.$set(
                                                                      _vm
                                                                        .dadosFormulario
                                                                        .configuracoes,
                                                                      "ecommerce",
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      )
                                                                    )
                                                                } else {
                                                                  $$i > -1 &&
                                                                    _vm.$set(
                                                                      _vm
                                                                        .dadosFormulario
                                                                        .configuracoes,
                                                                      "ecommerce",
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        )
                                                                    )
                                                                }
                                                              } else {
                                                                _vm.$set(
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes,
                                                                  "ecommerce",
                                                                  $$c
                                                                )
                                                              }
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                            Ecommerce\n                          "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              { staticClass: "mt-3" },
                                              [
                                                _c(
                                                  "b-col",
                                                  { staticClass: "col-md-3" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group"
                                                      },
                                                      [
                                                        _c("label", {
                                                          attrs: { for: "" }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-form-checkbox",
                                                          {
                                                            model: {
                                                              value:
                                                                _vm.hasCatalogo,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.hasCatalogo = $$v
                                                              },
                                                              expression:
                                                                "hasCatalogo"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Enviar Catálogos?\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { staticClass: "col-md-3" },
                                                  [
                                                    _vm.hasCatalogo
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-group"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Qtd. Catálogo:"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "mask",
                                                                  rawName:
                                                                    "v-mask",
                                                                  value: [
                                                                    "######"
                                                                  ],
                                                                  expression:
                                                                    "['######']"
                                                                },
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .configuracoes
                                                                      .qtd_catalogo,
                                                                  expression:
                                                                    "dadosFormulario.configuracoes.qtd_catalogo"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                type: "text",
                                                                readonly:
                                                                  _vm.readOnly
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .dadosFormulario
                                                                    .configuracoes
                                                                    .qtd_catalogo
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .dadosFormulario
                                                                      .configuracoes,
                                                                    "qtd_catalogo",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: "Anexos",
                                      "title-item-class":
                                        "bg-primary text-secondary"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      { attrs: { header: "Anexos" } },
                                      [
                                        (_vm.perfil === "financeiro" ||
                                          _vm.perfil === "adm" ||
                                          _vm.perfil === "cobranca") &&
                                        _vm.dadosFormulario.configuracoes
                                          .status === "AGUARDANDO"
                                          ? _c(
                                              "div",
                                              { staticClass: "checkbox" },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.visaoAnexoLista,
                                                        expression:
                                                          "visaoAnexoLista"
                                                      }
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.visaoAnexoLista
                                                      )
                                                        ? _vm._i(
                                                            _vm.visaoAnexoLista,
                                                            null
                                                          ) > -1
                                                        : _vm.visaoAnexoLista
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm.visaoAnexoLista,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.visaoAnexoLista = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.visaoAnexoLista = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.visaoAnexoLista = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                            Lista"
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.visaoAnexoLista
                                          ? _c(
                                              "b-card-body",
                                              _vm._l(
                                                _vm.dadosFormulario.anexos,
                                                function(anexo, index) {
                                                  return _c(
                                                    "div",
                                                    { key: anexo.id },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              target: "_blank",
                                                              rel:
                                                                "noopener noreferrer",
                                                              href:
                                                                anexo.url_arquivo
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                anexo.descricao
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        (_vm.perfil ===
                                                          "financeiro" ||
                                                          _vm.perfil ===
                                                            "adm" ||
                                                          _vm.perfil ===
                                                            "cobranca") &&
                                                        _vm.dadosFormulario
                                                          .configuracoes
                                                          .status ===
                                                          "AGUARDANDO"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "checkbox"
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .dadosFormulario
                                                                            .anexos[
                                                                            index
                                                                          ]
                                                                            .aprovado,
                                                                        expression:
                                                                          "dadosFormulario.anexos[index].aprovado"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      type:
                                                                        "checkbox"
                                                                    },
                                                                    domProps: {
                                                                      checked: Array.isArray(
                                                                        _vm
                                                                          .dadosFormulario
                                                                          .anexos[
                                                                          index
                                                                        ]
                                                                          .aprovado
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm
                                                                              .dadosFormulario
                                                                              .anexos[
                                                                              index
                                                                            ]
                                                                              .aprovado,
                                                                            null
                                                                          ) > -1
                                                                        : _vm
                                                                            .dadosFormulario
                                                                            .anexos[
                                                                            index
                                                                          ]
                                                                            .aprovado
                                                                    },
                                                                    on: {
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm
                                                                              .dadosFormulario
                                                                              .anexos[
                                                                              index
                                                                            ]
                                                                              .aprovado,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c = $$el.checked
                                                                            ? true
                                                                            : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v = null,
                                                                            $$i = _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .dadosFormulario
                                                                                  .anexos[
                                                                                  index
                                                                                ],
                                                                                "aprovado",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .dadosFormulario
                                                                                  .anexos[
                                                                                  index
                                                                                ],
                                                                                "aprovado",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .dadosFormulario
                                                                              .anexos[
                                                                              index
                                                                            ],
                                                                            "aprovado",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(
                                                                    "\n                            Aprovado"
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("br")
                                                      ])
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _c("b-card-body", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "row",
                                                  class: {
                                                    "opened-folder":
                                                      _vm.anexoFolderOpened > 0
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.anexoFolderOpened >
                                                                0,
                                                              expression:
                                                                "anexoFolderOpened > 0"
                                                            }
                                                          ],
                                                          attrs: {
                                                            size: "sm",
                                                            variant: "secondary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.setOpenedFolderAnexo(
                                                                0
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-arrow-circle-left"
                                                          }),
                                                          _vm._v(
                                                            " Voltar p/\n                          Pastas\n                        "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.anexoFolderOpened > 0
                                                        ? _c(
                                                            "b-button",
                                                            {
                                                              staticClass:
                                                                "mr-3",
                                                              attrs: {
                                                                size: "sm",
                                                                variant:
                                                                  "primary"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.addAnexo()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-plus"
                                                              }),
                                                              _vm._v(
                                                                " Adicionar novo Arquivo\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "section-card-folders"
                                                    },
                                                    _vm._l(
                                                      _vm.tiposAnexos,
                                                      function(tipoAnexo, idx) {
                                                        return _vm.anexoFolderOpened ===
                                                          0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                key: idx,
                                                                staticClass:
                                                                  "card-folder",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setOpenedFolderAnexo(
                                                                      tipoAnexo.id
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fa fa-folder fa-3x"
                                                                }),
                                                                _vm._v(" "),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      tipoAnexo.descricao
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                                _vm.validaArquivo(
                                                                  tipoAnexo
                                                                )
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "card-folder-required"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "*"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.dadosFormulario.anexos,
                                                    function(anexo, index) {
                                                      return _c(
                                                        "div",
                                                        { key: anexo.id },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.anexoFolderOpened ===
                                                                    anexo.id_anexo,
                                                                  expression:
                                                                    "anexoFolderOpened === anexo.id_anexo"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "container-anexo"
                                                            },
                                                            [
                                                              _c(
                                                                "v-input-file",
                                                                {
                                                                  ref:
                                                                    "arquivosObrigatorios",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    name:
                                                                      "Arquivo",
                                                                    id:
                                                                      "file_input_" +
                                                                      index,
                                                                    type: "pdf",
                                                                    fileURL:
                                                                      anexo.url_arquivo,
                                                                    extensions: anexo.tipos_aceitos.split(
                                                                      ","
                                                                    )
                                                                  },
                                                                  on: {
                                                                    remove:
                                                                      _vm.deletarURL
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      anexo.file,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        anexo,
                                                                        "file",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "anexo.file"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        anexo.descricao
                                                                      ) +
                                                                      "\n                          "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              !_vm.tipoCadastro
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "checkbox"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "model",
                                                                                  rawName:
                                                                                    "v-model",
                                                                                  value:
                                                                                    _vm
                                                                                      .dadosFormulario
                                                                                      .anexos[
                                                                                      index
                                                                                    ]
                                                                                      .aprovado,
                                                                                  expression:
                                                                                    "dadosFormulario.anexos[index].aprovado"
                                                                                }
                                                                              ],
                                                                              attrs: {
                                                                                type:
                                                                                  "checkbox"
                                                                              },
                                                                              domProps: {
                                                                                checked: Array.isArray(
                                                                                  _vm
                                                                                    .dadosFormulario
                                                                                    .anexos[
                                                                                    index
                                                                                  ]
                                                                                    .aprovado
                                                                                )
                                                                                  ? _vm._i(
                                                                                      _vm
                                                                                        .dadosFormulario
                                                                                        .anexos[
                                                                                        index
                                                                                      ]
                                                                                        .aprovado,
                                                                                      null
                                                                                    ) >
                                                                                    -1
                                                                                  : _vm
                                                                                      .dadosFormulario
                                                                                      .anexos[
                                                                                      index
                                                                                    ]
                                                                                      .aprovado
                                                                              },
                                                                              on: {
                                                                                change: function(
                                                                                  $event
                                                                                ) {
                                                                                  var $$a =
                                                                                      _vm
                                                                                        .dadosFormulario
                                                                                        .anexos[
                                                                                        index
                                                                                      ]
                                                                                        .aprovado,
                                                                                    $$el =
                                                                                      $event.target,
                                                                                    $$c = $$el.checked
                                                                                      ? true
                                                                                      : false
                                                                                  if (
                                                                                    Array.isArray(
                                                                                      $$a
                                                                                    )
                                                                                  ) {
                                                                                    var $$v = null,
                                                                                      $$i = _vm._i(
                                                                                        $$a,
                                                                                        $$v
                                                                                      )
                                                                                    if (
                                                                                      $$el.checked
                                                                                    ) {
                                                                                      $$i <
                                                                                        0 &&
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .dadosFormulario
                                                                                            .anexos[
                                                                                            index
                                                                                          ],
                                                                                          "aprovado",
                                                                                          $$a.concat(
                                                                                            [
                                                                                              $$v
                                                                                            ]
                                                                                          )
                                                                                        )
                                                                                    } else {
                                                                                      $$i >
                                                                                        -1 &&
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .dadosFormulario
                                                                                            .anexos[
                                                                                            index
                                                                                          ],
                                                                                          "aprovado",
                                                                                          $$a
                                                                                            .slice(
                                                                                              0,
                                                                                              $$i
                                                                                            )
                                                                                            .concat(
                                                                                              $$a.slice(
                                                                                                $$i +
                                                                                                  1
                                                                                              )
                                                                                            )
                                                                                        )
                                                                                    }
                                                                                  } else {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .dadosFormulario
                                                                                        .anexos[
                                                                                        index
                                                                                      ],
                                                                                      "aprovado",
                                                                                      $$c
                                                                                    )
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                            Aprovado"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  staticClass:
                                                                    "mt-2",
                                                                  attrs: {
                                                                    variant:
                                                                      "danger",
                                                                    size: "sm"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeAnexo(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-trash-alt"
                                                                  }),
                                                                  _vm._v(
                                                                    " Remover\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]),
                                        _vm._v(" "),
                                        !_vm.visaoAnexoLista
                                          ? _c(
                                              "b-card-footer",
                                              [
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c("b-col", [
                                                      _c("h6", [
                                                        _vm._v("Legenda:")
                                                      ])
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c("b-col", [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-primary"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          Anexo Obrigatório:"
                                                          ),
                                                          _c(
                                                            "strong",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "20px"
                                                              }
                                                            },
                                                            [_vm._v("*")]
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: "Observações",
                                      "title-item-class":
                                        "bg-primary text-secondary"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      [
                                        _c("b-card-body", [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-12 form-group"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [_vm._v("Novas Observações:")]
                                                ),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.observacoes,
                                                      expression: "observacoes"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    name: "",
                                                    id: "",
                                                    cols: "30",
                                                    rows: "5"
                                                  },
                                                  domProps: {
                                                    value: _vm.observacoes
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.observacoes =
                                                        $event.target.value
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.dadosFormulario.prospectoObservacoes,
                                      function(observacao, keyObs) {
                                        return _c(
                                          "div",
                                          {
                                            key: keyObs,
                                            staticClass: "row mt-4"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-12" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "card" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "card-body"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "observacoes"
                                                          },
                                                          [
                                                            _c("small", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  observacao.created_at
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-primary"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    observacao
                                                                      .user.name
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "\n                          escreveu:\n                          "
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-md-12"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      observacao.observacao
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.prospectoId > 0
                                  ? _c(
                                      "b-tab",
                                      {
                                        attrs: {
                                          title: "Consulta SPC",
                                          "title-item-class":
                                            "bg-primary text-secondary"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-card",
                                          [
                                            _c("b-card-body", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-right float-right",
                                                  staticStyle: {
                                                    "margin-top": "10px",
                                                    "margin-right": "10px"
                                                  }
                                                },
                                                [
                                                  _vm.prospectoId > 0
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          attrs: {
                                                            variant: "danger",
                                                            size: "sm"
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.showModalSPC
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Fazer nova Busca ao SPC\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "float-left" },
                                                [
                                                  _c(
                                                    "vConsultaReceitaFederal",
                                                    {
                                                      attrs: {
                                                        cnpj:
                                                          _vm.dadosFormulario
                                                            .empresa.cnpj
                                                      }
                                                    }
                                                  )
                                                ],
                                                1
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.consultasSPC, function(
                                          consulta,
                                          keyCon
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: keyCon,
                                              staticClass: "row mt-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c(
                                                    "b-card",
                                                    [
                                                      _c(
                                                        "b-card-body",
                                                        [
                                                          _vm._v(
                                                            "\n                        Consultado por\n                        "
                                                          ),
                                                          _c(
                                                            "strong",
                                                            {
                                                              staticClass:
                                                                "text-primary"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  consulta.name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "\n                        em " +
                                                              _vm._s(
                                                                _vm.formatDate(
                                                                  consulta.created_at
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                          _c(
                                                            "b-button",
                                                            {
                                                              staticClass:
                                                                "ml-3",
                                                              attrs: {
                                                                href:
                                                                  "/spc/" +
                                                                  consulta.id,
                                                                variant:
                                                                  "secondary",
                                                                size: "sm",
                                                                target: "_blank"
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-list-alt"
                                                              }),
                                                              _vm._v(
                                                                " Ver Consulta"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: {
                  id: "alertErro",
                  role: "dialog",
                  size: "lg",
                  title: "Erro"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "modal-footer",
                      fn: function() {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                "button-size": "sm"
                              },
                              on: {
                                click: function($event) {
                                  _vm.saveFormulario = false
                                }
                              }
                            },
                            [_vm._v("\n          Fechar\n        ")]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2813905561
                ),
                model: {
                  value: _vm.saveFormulario,
                  callback: function($$v) {
                    _vm.saveFormulario = $$v
                  },
                  expression: "saveFormulario"
                }
              },
              [
                _c("b-card", [
                  _c(
                    "ul",
                    _vm._l(_vm.erros, function(erro, e) {
                      return _c("li", { key: e }, [
                        _vm._v("\n            " + _vm._s(erro) + "\n          ")
                      ])
                    }),
                    0
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: { size: "lg", title: "Consulta SPC", "hide-footer": "" },
                model: {
                  value: _vm.openModalSPC,
                  callback: function($$v) {
                    _vm.openModalSPC = $$v
                  },
                  expression: "openModalSPC"
                }
              },
              [
                _c(
                  "b-card",
                  [
                    _c("b-card-title", [
                      _c("h4", { staticClass: "modal-title" }, [
                        _vm._v("Atenção")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("b-card-body", [
                      _vm._v(
                        "\n          Esta consulta gera Custos por Requisição, Deseja continuar?\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-card-footer",
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              disabled: _vm.loadingConsulta,
                              size: "sm",
                              variant: "success"
                            },
                            on: {
                              click: function($event) {
                                _vm.consultaSPC("J"), _vm.openModalSPC
                              }
                            }
                          },
                          [
                            _vm.loadingConsulta
                              ? _c("b-spinner", {
                                  attrs: { variant: "secondary", small: "" }
                                })
                              : _c("i", {
                                  staticClass: "fas fa-search-dollar"
                                }),
                            _vm._v("\n            Sim, Consultar CNPJ")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "float-right",
                            attrs: {
                              disabled: _vm.loadingConsulta,
                              size: "sm",
                              variant: "danger"
                            },
                            on: { click: _vm.showModalSPC }
                          },
                          [_vm._v("Cancelar")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: {
                  title: "Cadastros com Informações Coincidentes",
                  size: "lg"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "modal-footer",
                      fn: function() {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "secondary", size: "sm" },
                              on: {
                                click: function($event) {
                                  _vm.modalDuplicatas = false
                                }
                              }
                            },
                            [_vm._v("Fechar")]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3703243780
                ),
                model: {
                  value: _vm.modalDuplicatas,
                  callback: function($$v) {
                    _vm.modalDuplicatas = $$v
                  },
                  expression: "modalDuplicatas"
                }
              },
              [
                _c("p", { staticClass: "text-muted mb-3" }, [
                  _vm._v(
                    "\n        Os cadastros abaixo possuem telefone ou endereço iguais ao deste cadastro.\n      "
                  )
                ]),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    items: _vm.duplicatasEncontradas,
                    fields: [
                      { key: "id", label: "ID" },
                      { key: "nome", label: "Nome / Razão Social" },
                      { key: "codigo_distribuidor", label: "Código" },
                      { key: "status", label: "Status" },
                      { key: "coincidencia", label: "Coincidência" }
                    ],
                    striped: "",
                    hover: "",
                    small: "",
                    responsive: "",
                    "show-empty": "",
                    "empty-text": "Nenhum cadastro encontrado"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "cell(status)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  variant:
                                    row.item.status === "ATIVO"
                                      ? "success"
                                      : row.item.status === "INATIVO"
                                      ? "danger"
                                      : "warning"
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(row.item.status) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3430577789
                  )
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: {
                  title: "Centro de Distribuição",
                  "hide-footer": "",
                  "hide-header-close": "",
                  "no-close-on-backdrop": "",
                  "no-close-on-esc": ""
                },
                model: {
                  value: _vm.modalCd,
                  callback: function($$v) {
                    _vm.modalCd = $$v
                  },
                  expression: "modalCd"
                }
              },
              [
                _c(
                  "b-card",
                  [
                    _c("b-row", [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Selecione o Centro de Distribuição:")
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              disabled: _vm.perfil === "centro_distribuicao",
                              options: _vm.listaCentroDistribuicao
                            },
                            on: {
                              input: function($event) {
                                return _vm.closeModalCd()
                              },
                              change: function() {
                                _vm.setOptionsClasseDistribuidor()
                                _vm.validaRegiao()
                              }
                            },
                            model: {
                              value:
                                _vm.dadosFormulario.configuracoes
                                  .centro_distribuicao,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dadosFormulario.configuracoes,
                                  "centro_distribuicao",
                                  $$v
                                )
                              },
                              expression:
                                "dadosFormulario.configuracoes.centro_distribuicao"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c29cd3c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c29cd3c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_prospecto/Edit.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-9c29cd3c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_prospecto/Edit.vue
// module chunks = 2